module.exports = __webpack_public_path__ + "img/PowerRailAssign.32e866c9.svg";